/* @flow */
import * as React from 'react';
import ReactModal from 'react-modal';
import { withRouter } from 'app/context/Router';
import UsersInviteModal from 'users/components/UsersInviteModal';

type Props = {
  group: *,
  router: {
    replace: Function,
  },
};

class GroupInviteHandler extends React.Component<Props, {}> {
  redirectToRoot = () => this.props.router.replace('/classes/' + this.props.group.getCode());

  render() {
    return (
      <ReactModal isOpen>
        <UsersInviteModal group={this.props.group} onRequestHide={this.redirectToRoot} />
      </ReactModal>
    );
  }
}

export default withRouter(GroupInviteHandler);
